import React from "react";
import styles from "./MaintenanceModal.module.sass";
import { Modal } from "react-bootstrap";
import AppContext from "../../contexts/appContext";
import { isMaintenancePeriod } from "../../utils/maintenance";

class MaintenanceModal extends React.Component {
  static contextType = AppContext;

  hideHandler = () => {
    this.context.setContext({
      ...this.context,
      maintenanceAccepted: "S",
    });
  };

  render() {
    return (
      <Modal
        centered
        dialogClassName={styles.modalDialog}
        show={this.context.maintenanceAccepted === "N" && isMaintenancePeriod()}
        onHide={this.hideHandler}
      >
        <Modal.Header closeButton>
          <h1>Aviso</h1>
        </Modal.Header>
        <Modal.Body>
          <p>
            Estamos realizando algumas evoluções importantes no nosso sistema
            entre 10 e 12 de outubro e, por isso, podem ocorrer
            indisponibilidades momentâneas na simulação e na compra de cartas de
            consórcio. Tudo voltará ao normal a partir do dia 13/10. Obrigado
            pela compreensão.
          </p>
        </Modal.Body>
      </Modal>
    );
  }
}

export default MaintenanceModal;
